var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "fit-content" } }, [
    _c(
      "div",
      { staticClass: "TextFlag" },
      [
        _c(
          "div",
          {
            staticClass: "movePointer",
            on: { mousedown: _vm.draggbleMove, mouseup: _vm.changeBlur }
          },
          [_c("i", { staticClass: "el-icon-rank" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "Flagitem kefu",
            staticStyle: { background: "#ffffff" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href:
                    "http://wpa.qq.com/msgrd?v=3&uin=2211904562&site=qq&menu=yes"
                }
              },
              [
                _c("div", { staticClass: "showNav" }, [
                  _c("div", { staticClass: "TB_center" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "tipText" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_online_chat")))
                    ])
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-popover",
          {
            attrs: {
              placement: "left",
              title: _vm.$t("i18n_cititrans"),
              width: "450",
              trigger: "hover"
            }
          },
          [
            _c("div", [
              _c("div", { staticClass: "showCouText" }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [
                    _c("i", { staticClass: "el-icon-position" }),
                    _vm._v(" " + _vm._s(_vm.$t("i18n_Address")) + "：")
                  ]
                ),
                _vm._v(_vm._s(_vm.$t("i18n_cititrans_address")) + "\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "showCouText" }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [
                    _c("i", { staticClass: "el-icon-phone" }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("i18n_hotline_number")) +
                        "："
                    )
                  ]
                ),
                _vm._v("181-0280-6672\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "showCouText" }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [
                    _c("i", { staticClass: "el-icon-phone" }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("i18n_customer_service")) +
                        "："
                    )
                  ]
                ),
                _vm._v("＋86-755-82143176\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "showCouText" }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [
                    _c("i", { staticClass: "el-icon-printer" }),
                    _vm._v("\n            " + _vm._s(_vm.$t("i18n_fax")) + "：")
                  ]
                ),
                _vm._v("＋86 755-82143174\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "showCouText" }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [
                    _c("i", { staticClass: "el-icon-message" }),
                    _vm._v(
                      "\n            " + _vm._s(_vm.$t("i18n_Email")) + "："
                    )
                  ]
                ),
                _vm._v("info@cititrans.com\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "showCouText" }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [
                    _c("i", { staticClass: "el-icon-chat-dot-round" }),
                    _vm._v(
                      "\n            " + _vm._s(_vm.$t("i18n_WeChat_ID")) + "："
                    )
                  ]
                ),
                _vm._v("181-0280-6672\n        ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    gap: "5px",
                    "justify-content": "flex-start",
                    width: "100%"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "100px", "font-size": "14px" } },
                    [
                      _c("i", { staticClass: "el-icon-service" }),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("i18n_Online_WeChat_Customer_service")
                          ) +
                          ":\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("img", {
                      staticStyle: {
                        display: "inline-block",
                        width: "130px",
                        height: "130px"
                      },
                      attrs: {
                        src:
                          "https://0.rc.xiniu.com/g3/M00/07/62/CgAH6F2_5qSAbJcHAABJJ6mvWhI105.png",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100%",
                          "text-align": "center",
                          "font-size": "11px",
                          color: "#999"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("i18n_scan_qr_code_for_service")) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "Flagitem",
                attrs: { slot: "reference" },
                slot: "reference"
              },
              [
                _c("div", { staticClass: "showNav" }, [
                  _c("div", { staticClass: "TB_center" }, [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: require("./../static/images/ip.png"),
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.$t("i18n_contact_us")))])
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-popover",
          { attrs: { placement: "left", width: "100", trigger: "hover" } },
          [
            _c("div", [
              _c("img", {
                staticStyle: { width: "150px", height: "150px" },
                attrs: {
                  src: require("./../static/images/xcximg.jpg"),
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "Flagitem",
                attrs: { slot: "reference" },
                slot: "reference"
              },
              [
                _c("div", { staticClass: "showNav" }, [
                  _c("div", { staticClass: "TB_center" }, [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: require("./../static/images/xcx.png"),
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tipText" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_mini_program")))
                    ])
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-popover",
          { attrs: { placement: "left", width: "400", trigger: "hover" } },
          [
            _c("div", [
              _c("ul", [
                _c(
                  "li",
                  {
                    staticClass: "showCouText",
                    staticStyle: { "line-height": "24px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "warhouse_tit" },
                      [
                        _vm._v(
                          "\n              【" +
                            _vm._s(_vm.$t("i18n_warehouse_dongguan")) +
                            "】\n              "
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          { attrs: { size: "small", effect: "dark" } },
                          [_vm._v(_vm._s(_vm.$t("i18n_warehouse_air_sea")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "el-icon-position" }),
                      _vm._v(
                        _vm._s(_vm.$t("i18n_Address")) +
                          "：" +
                          _vm._s(_vm.$t("i18n_warehouse_dongguan_address")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "el-icon-phone" }),
                      _vm._v(
                        _vm._s(_vm.$t("i18n_warehouse_dongguan_contact")) +
                          "\n            "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "showCouText",
                    staticStyle: { "line-height": "24px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "warhouse_tit" },
                      [
                        _vm._v(
                          "\n              【" +
                            _vm._s(_vm.$t("i18n_warehouse_foshan")) +
                            "】\n              "
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          { attrs: { size: "small", effect: "dark" } },
                          [_vm._v(_vm._s(_vm.$t("i18n_warehouse_sea")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "el-icon-position" }),
                      _vm._v(
                        _vm._s(_vm.$t("i18n_Address")) +
                          "：" +
                          _vm._s(_vm.$t("i18n_warehouse_foshan_address")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "el-icon-phone" }),
                      _vm._v(
                        _vm._s(_vm.$t("i18n_warehouse_foshan_contact")) +
                          "\n            "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "showCouText",
                    staticStyle: { "line-height": "24px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "warhouse_tit" },
                      [
                        _vm._v(
                          "\n              【" +
                            _vm._s(_vm.$t("i18n_warehouse_yiwu")) +
                            "】\n              "
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          { attrs: { size: "small", effect: "dark" } },
                          [_vm._v(_vm._s(_vm.$t("i18n_warehouse_sea")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "el-icon-position" }),
                      _vm._v(
                        _vm._s(_vm.$t("i18n_Address")) +
                          "：" +
                          _vm._s(_vm.$t("i18n_warehouse_yiwu_address")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "el-icon-phone" }),
                      _vm._v(
                        _vm._s(_vm.$t("i18n_warehouse_yiwu_contact")) +
                          "\n            "
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "Flagitem",
                attrs: { slot: "reference" },
                slot: "reference"
              },
              [
                _c("div", { staticClass: "showNav" }, [
                  _c("div", { staticClass: "TB_center" }, [
                    _c("div", [
                      _c("img", {
                        staticStyle: { width: "30px" },
                        attrs: {
                          src: require("./../static/images/warehouse_ico.png"),
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tipText" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_warehosue_information")))
                    ])
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "Flagitem",
            staticStyle: {
              display: "flex",
              "align-items": "center",
              "justify-content": "center"
            },
            on: { click: _vm.toTop }
          },
          [_vm._m(1)]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: { src: require("./../static/images/kf.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "showNav" }, [
      _c("div", { staticClass: "TB_center" }, [
        _c("div", [
          _c("img", {
            attrs: { src: require("./../static/images/top.png"), alt: "" }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e007e6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e007e6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./common/serviceText.vue
// module id = null
// module chunks = 